"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var Placeholder =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Placeholder, _PureComponent);

  function Placeholder() {
    (0, _classCallCheck2.default)(this, Placeholder);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Placeholder).apply(this, arguments));
  }

  (0, _createClass2.default)(Placeholder, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          showPlaceholder = _this$props.showPlaceholder,
          className = _this$props.className,
          text = _this$props.text;
      return showPlaceholder ? _react.default.createElement("div", {
        className: (0, _classnames.default)('react-tinymce-placeholder', className),
        style: {
          position: 'absolute',
          top: 0
        }
      }, text) : null;
    }
  }]);
  return Placeholder;
}(_react.PureComponent);

Placeholder.propTypes = {
  showPlaceholder: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  text: _react.PropTypes.string
};
Placeholder.defaultProps = {
  showPlaceholder: false,
  className: ''
};
var _default = Placeholder;
exports.default = _default;
module.exports = exports.default;